export const KEY_FILTER = {
  ANYTHING: /[\s\S]*/,
};
